<template lang="html"  slot-scope="props">
  <notifications group="note"
  position="top center" :duration="notiDuration" width="500">
  <template slot="body" slot-scope="props">
    <div class="note d-flex justify-content-between " :class="props.item.type">
      <!-- <div class="d-flex"> -->
        <div class="noti-icon">
          <v-icon :name="props.item.type == 'error' ? 'alert-circle' : 'check'"></v-icon>
        </div>
        <div class="note-content">
          <div v-html="props.item.text">
          </div>
        </div>
      <!-- </div> -->
      <div class="close-icon noti-icon" @click="props.close">
        <v-icon name='x'></v-icon>
      </div>
    </div>
  </template>
</notifications>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState({
      notiDuration: state => state.TerminalService.notiDuration
    })
  },

  methods: {
    // getClass: function(type) {
    //   if(type == 'success') {
    //     return {
    //
    //     }
    //   }
    // }
  }
};
</script>

<style lang="css" scoped>
* {
  font-family: Jura;
  font-size: 16px;
}
.note {
  text-align: left;
  /* right: 1000px; */
  height: 64px;
  padding: 15px;
  color: white;
  margin-bottom: 15px;
  padding-left: 32px;
  padding-right: 32px;
}

.notifications-close {
  /* border-radius: 50%;
  border: 2px solid white; */
  height: 20px;
  width: 20px;
  color: white;
  /* font-size: 17px; */
  /* background-color: red; */
}

.note-content {
  font-weight: bold;
  margin-top: 3px;
  margin-left: 8px;
  /* margin-right: 96px; */
}

.icon {
  height: 24px;
  width: 24px;
  color: #ffffff;
  margin-top: 2px;
}

.icon-check {
  border: 2px solid white;
  border-radius: 50%;
}

.close-icon:hover {
  cursor: pointer;
}

.success {
  background-color: rgb(23, 112, 133, 0.64);
}

.error {
  background-color: rgb(245, 166, 35, 0.64);
}
</style>



// WEBPACK FOOTER //
// src/components/base/notification.vue